// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"56850576","186":"39caba51","215":"cd9e6443","372":"9fca7d91","377":"728d49a7","630":"6294f51a","738":"af612e4d","841":"f1b9a605","851":"3b486174","856":"8bf10a8e"}[chunkId] + ".chunk.js";
};